// src/hooks/useSheet.js
import { useEffect, useState } from 'react';

export const useSheet = (sheetId, sheetName) => {
  const url = `https://docs.google.com/spreadsheets/d/${sheetId}/gviz/tq?tqx=out:json&sheet=${sheetName}`;
  const [rows, setRows] = useState([]);

  useEffect(() => {
    let isMounted = true;

    const fetchData = async () => {
      try {
        const response = await fetch(url);
        const text = await response.text();
        const start = text.indexOf('{');
        const end = text.lastIndexOf('}') + 1;
        const json = JSON.parse(text.slice(start, end));
        const table = json.table.rows.map(r => r.c.map(c => (c ? c.v : null)));
        if (isMounted) setRows(table);
      } catch (err) {
        console.error(`Error fetching sheet "${sheetName}":`, err);
      }
    };

    // initial fetch
    fetchData();

    // poll every 60 seconds
    const intervalId = setInterval(fetchData, 60000);

    return () => {
      isMounted = false;
      clearInterval(intervalId);
    };
  }, [url, sheetName]);

  return rows;
};
